import { fk, attr } from "redux-orm";
import Model from "../base-model";
import libraryDocumentReducers from "./libraryDocument.reducer";
import { libraryDocumentActions } from "./libraryDocument.action";

export class LibraryDocument extends Model {
    static reducer(action, Self, session) {
        switch (action.type) {
            case libraryDocumentActions.save:
                libraryDocumentReducers.save(
                    session,
                    action.document,
                    action.courseId
                );
                break;
            default:
                return undefined;
        }
    }

    toString() {
        return `LibraryDocument: ${this.id}`;
    }
}

LibraryDocument.modelName = "LibraryDocument";

LibraryDocument.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    image: attr(),
    thumbnail: attr(),
    file: attr(),
    link: attr(),
    createdAt: attr(),
    authorName: attr(),
    course: fk("Course", "libraryDocuments")
};
